import React, { useState, useRef } from "react";
import "../../../styles/VocabularyPractice.css";
import { officeVocab } from "../../../data/part3/vocabulary/officeVocab";

const VocabularyPractice = ({ onBack }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showMeaning, setShowMeaning] = useState(false);
  const audioRef = useRef(null);

  const vocabularyList = officeVocab;

  const handlePlayAudio = () => {
    const word = vocabularyList[currentIndex].word;
    const audio = new Audio(`/audios/vocabulary/${word}.mp3`);
    audio.play();
  };

  const renderCard = () => {
    if (!vocabularyList) {
      return <div>데이터를 불러올 수 없습니다.</div>;
    }

    const currentWord = vocabularyList[currentIndex];
    if (!currentWord) {
      return <div>단어를 찾을 수 없습니다.</div>;
    }

    return (
      <div className="card-container">
        <div className="card">
          <button className="audio-button" onClick={handlePlayAudio}>
            🔊
          </button>
          <button
            className="meaning-button"
            onClick={() => setShowMeaning(!showMeaning)}
          >
            {showMeaning ? "뜻 숨기기" : "뜻 보기"}
          </button>

          {showMeaning && (
            <div className="word-content">
              <h2>{currentWord.word}</h2>
              <h3>{currentWord.meaning}</h3>
              <p className="example">{currentWord.example}</p>
              <p className="translation">{currentWord.translation}</p>
            </div>
          )}
        </div>

        <div className="navigation-buttons">
          <button
            onClick={() => {
              setCurrentIndex((prev) => Math.max(0, prev - 1));
              setShowMeaning(false);
            }}
            disabled={currentIndex === 0}
          >
            이전
          </button>
          <span>
            {currentIndex + 1} / {vocabularyList.length}
          </span>
          <button
            onClick={() => {
              setCurrentIndex((prev) =>
                Math.min(vocabularyList.length - 1, prev + 1)
              );
              setShowMeaning(false);
            }}
            disabled={currentIndex === vocabularyList.length - 1}
          >
            다음
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="vocabulary-practice-container">
      <div className="header">
        <h2>토익 필수 단어 학습</h2>
        <button className="back-button" onClick={onBack}>
          메인으로
        </button>
      </div>
      {renderCard()}
    </div>
  );
};

export default VocabularyPractice;
